import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Divider,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Checkbox,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { ReactComponent as UploadFileIcon } from "../../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { ReactComponent as FormIcon } from "../../../../Icons/CommonFormIcon.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers";
import PhoneInputController from "../../../../CommonComponents/PhoneInputController";
import { useTranslation } from "react-i18next";

export default function Agreement({ setStepperCount, formData, setFormData }) {
  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
    trigger,
  } = useForm({
    mode: "onTouched",
  });

  const {t} = useTranslation()
  const navigate = useNavigate();
  const data = useSelector((state) => state.AdminData.admin);
  const [allData, setAllData] = useState({});
  const [checked, setChecked] = useState(false);
  const {id} = useParams()
  const Imgwatch = watch("img");

  const imgFile = useRef();

  const [bgImg, setBgImg] = useState([]);
  const handleNext = async () => {
    const isFormValid = await trigger();

    if (isFormValid) {
      setStepperCount(2);
    }
  };
  useEffect(() => {
    if (Boolean(Imgwatch)) {
      setBgImg((prev) => []);

      Array.from(Imgwatch)?.map((item, index) =>
        setBgImg((prev) => [...prev, { id: index + 1, img: item }])
      );
    }
  }, [Imgwatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}get-paiduser-by-id/${data.id}`)
      .then((response) => {
        console.log(response, "paid user");
        if (response.status === 200) {
          if (response?.data?.data.tenancyAgreement) {
            setValue("name", response?.data?.data?.tenancyAgreement.name);
            setValue(
              "passport",
              response?.data?.data?.tenancyAgreement.passport_no
            );
            setValue(
              "finnumber",
              response?.data?.data?.tenancyAgreement.fin_no
            );
            setValue("img", [response?.data?.data?.tenancyAgreement.signature]);
            setChecked(response.data.data.tenancyAgreement.agreement);
          } else {
            setValue("name", response?.data?.data?.PersonalData?.Details?.name);
            setValue(
              "passport",
              response?.data?.data?.PersonalData?.Details?.passport_no
            );
          }
          setAllData(response.data.data);
        }
      })
      .catch((error) => console.log(error));
  };

  // const fetchTenancyAgreement = async () => {
  //     await axios.get(`${process.env.REACT_APP_API_URL}get-tenancy-agreement/${data.id}`)
  //     .then((response) => {
  //       console.log(response)
  //     }).catch((error) => {
  //       console.log(error)
  //     })
  // }

  // useEffect(() => {
  //   if (data?.id) {
  //     fetchData();
  //   }
  // }, []);

  const handleChange = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    setValue('name', formData?.name)
    setValue('phone', formData?.phone)
    setValue('email', formData?.email)
    setValue('line', formData?.line)
    setValue('wechat', formData?.wechat)
    setValue('whatsapp', formData?.whatsapp)
    setValue('flightno', formData?.flightno)
    setValue('arrival_date', formData?.arrival_date)
    setValue('luggageCount', formData?.luggageCount)
  }, [formData])

  const onSubmit = async (dataa) => {
    console.log(dataa);
    setFormData(dataa)
    handleNext()
    // const sendObj = new FormData();
    // sendObj.append("name", dataa?.name);
    // sendObj.append("fin_no", dataa?.finnumber);
    // sendObj.append("passport_no", dataa?.passport);
    // sendObj.append("signature", dataa?.img[0]);
    // sendObj.append("agreement", checked);
    // await axios
    //   .put(
    //     `${process.env.REACT_APP_API_URL}add-tenancy-agreement/${data.id}`,
    //     sendObj,
    //     {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     console.log(response);
    //     if (response.status == 200) {
    //       setStepperCount(2);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };

  const deleteFirstImage = (id) => {
    let updatedFiles = Array.from(Imgwatch);
    updatedFiles = updatedFiles.filter((file, index) => index !== id);
    setValue("img", updatedFiles);
  };

  return (
    <Box px={{ md: 10, xs: 3 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
      <Box>
          <Typography sx={{ fontSize: "24px" }}>
            {t("Personal Information")}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            mt: 2,
            gap: 2,
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mt: 2,
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.name ? `${t("name")}*` : `${t("name")}*`}
            </InputLabel>
            <Controller
              name="name"
              control={control}
              rules={{ required: "Name is required",
              maxLength: {
                value: 50,
                message: "Name cannot exceed 50 characters"
              } }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter name"
                  error={Boolean(errors?.name) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.name ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.name
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.name
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.name
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.name ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                {errors?.name?.message}
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mt: 2,
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.phone ? `${t("Phone")}*` : `${t("Phone")}*`}
            </InputLabel>
            <PhoneInputController
        name="phone"
        control={control}
        rules={{ required: 'Phone number is required' }}
      />
            {errors?.phone ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                {errors?.phone?.message}
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mt: 2,
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.email ? `${t("email")}*` : `${t("email")}*`}
            </InputLabel>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter a valid email address",
                },
              }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter email"
                  error={Boolean(errors?.email) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.email ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.email
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.email
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.email
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.email ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                {errors?.email?.message}
              </Typography>
            ) : null}
          </Box>
        </Box>

        <Divider sx={{ mt: 4, mb: 4 }} />

        <Box>
          <Typography sx={{ fontSize: "24px" }}>{t("Contact Preferences")}</Typography>
          <Divider sx={{ mt: 2, mb: 2 }} />

          <Box
            sx={{
              display: "flex",
              mt: 2,
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ width: {xs : '100%', md : "45%"}}}>
              <InputLabel
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.line ? `${t("line")}*` : `${t("line")}*`}
              </InputLabel>
              <Controller
              name="line"
              control={control}
              rules={{ required: "LINE is required",
              maxLength: {
                value: 70,
                message: "LINE cannot exceed 70 characters"
              } }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter line"
                  error={Boolean(errors?.line) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.line ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.line
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.line
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.line
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
              {errors?.line ? (
                <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                  {errors?.line?.message}
                </Typography>
              ) : null}
            </Box>

            <Box sx={{ width: {xs : '100%', md : "45%"}}}>
              <InputLabel
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.wechat ? `${t("wechat")}*` : `${t("wechat")}*`}
              </InputLabel>
              <Controller
              name="wechat"
              control={control}
              rules={{ required: "WeChat is required",
              maxLength: {
                value: 70,
                message: "WeChat cannot exceed 70 characters"
              } }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter wechat"
                  error={Boolean(errors?.wechat) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.wechat ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.wechat
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.wechat
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.wechat
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
              {errors?.wechat ? (
                <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                  {errors?.wechat?.message}
                </Typography>
              ) : null}
            </Box>

            <Box sx={{ width: {xs : '100%', md : "45%"}}}>
              <InputLabel
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.whatsapp ? `${t("whatsapp")}*` : `${t("whatsapp")}*`}
              </InputLabel>
              <Controller
              name="whatsapp"
              control={control}
              rules={{ required: "WhatsApp is required",
              maxLength: {
                value: 70,
                message: "WhatsApp cannot exceed 70 characters"
              } }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter whatsapp"
                  error={Boolean(errors?.whatsapp) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.whatsapp ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.whatsapp
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.whatsapp
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.whatsapp
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
              {errors?.whatsapp ? (
                <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                  {errors?.whatsapp?.message}
                </Typography>
              ) : null}
            </Box>
          </Box>
        </Box>

        <Divider sx={{ mt: 4, mb: 2 }} />

        <Box>
          <Typography sx={{ fontSize: "24px" }}>{t("Travel Details")}</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            mt: 2,
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.flightno ? `${t("Flight Number")}*` : `${t("Flight Number")}*`}
            </InputLabel>
            <Controller
              name="flightno"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter Flight No"
                  error={Boolean(errors?.flightno) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.flightno ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.flightno
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.flightno
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.flightno
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.flightno ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                Please enter Flight No
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.luggageCount ? `${t("Luggage Count")}*` : `${t("Luggage Count")}*`}
            </InputLabel>
            <Controller
              name="luggageCount"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter luggage count"
                  error={Boolean(errors?.luggageCount) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.luggageCount ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.luggageCount
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.luggageCount
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.luggageCount
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.flightno ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                Please enter luggage count
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.arrival_date
                ? `${t("Arrival date and time")}*`
                : `${t("Arrival date and time")}*`}
            </InputLabel>
            <Controller
              name="arrival_date"
              // defaultValue={arrival_date ? dayjs(arrival_date) : null}
              control={control}
              rules={{
                required: "Arrival date is required",
                validate: (value) =>
                  value && dayjs(value).isAfter(dayjs()) ? true : "Date must be in the future",
              }}
              render={({ field }) => (
                <DateTimePicker
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    ".MuiSvgIcon-root": { fill: "#1A2461" },
                    "& .MuiInputBase-input": {
                      color: errors?.arrival_date ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.arrival_date
                          ? "red"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.arrival_date
                          ? "red"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.arrival_date
                          ? "red"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                  //label="Select Date and Time"
                  minDateTime={dayjs()}
                  renderInput={(params) => <TextField {...params} />}
                  format="DD/MM/YYYY hh:mm A"
                  fullWidth
                />
              )}
            />
            {errors?.arrival_date && (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                {errors?.arrival_date?.message}
              </Typography>
            )}
          </Box>
        </Box>
        <Box
        sx={{ mt: 6, mb: 6, display: "flex", justifyContent: "space-between" }}
      >
        <Button
        onClick={()=> navigate(`/services/${id}`)}
          variant="standard"
         
        >
          {t("Back")}
        </Button>
        <Button
          type='submit'
          variant="standard"
          
        >
          {t("Continue")}
        </Button>
      </Box>
      </form>

      
    </Box>
  );
}
